import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface TimeRangeStore {
    followNow: boolean;
    setFollowNow: (followNow: boolean) => void;
}

export const useTimeRangeStore = create<TimeRangeStore>()(
    devtools(
        (set) => ({
            followNow: true,
            setFollowNow: (followNow) => set({ followNow })
        }),
        { name: 'time-range-store' }
    )
);
